import { render, staticRenderFns } from "./IPage.vue?vue&type=template&id=767c4f47&"
import script from "./IPage.vue?vue&type=script&lang=js&"
export * from "./IPage.vue?vue&type=script&lang=js&"
import style0 from "./IPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});qInstall(component, 'directives', {ClosePopup});
